import axios from '@/libs/api.request.js';

const user = {

    // 获取账户基本信息
    getBaseInfo: () => {
        return axios.get({
            url: '/wap/Account/baseinfo'
        })
    },
    // 获取账户的用户信息
    getUserinfo: () => {
        return axios.get({
            url: '/wap/Account/userinfo'
        })
    },
    // 设置或修改用户信息，其中性别不为未知的不予修改，生日标志位为1的不予修改
    setUserinfo: (data) => {
        return axios.put({
            url: '/wap/Account/userinfo',
            data: data
        })
    },
    // 获取当前可用的开卡策略
    getUserRules: () => {
        return axios.get({
            url: '/wap/User/Rules'
        })
    },
    //用户关注状态
    userSubscribeStatus: () => {
    return axios.get({
      url: '/wap/User/userStatus'
    })
  },
};

export default user;



// WEBPACK FOOTER //
// ./src/api/api-user.js